export const SWIPE_DISTANCE_LIMIT = 50;
